<template functional>
    <form-group :label="props.label" :help="props.help"
                :class="[data.staticClass, {'error' : props.v ? props.v.$error : null}]">
        <textarea :rows="props.rows ? props.rows : 5" :type="props.type ? props.type: 'text'"
                  class="form-control"
                  :class="props.inputClass"
                  :placeholder="props.placeholder"
                  :value="props.value"
                  :disabled="props.disabled"
                  :readonly="props.readonly"
                  v-on:input="($event) => {
                      listeners.input && listeners.input($event.target.value);
                      if(props.v){
                           props.v.$touch();
                      }
                  }"
        />
    </form-group>
</template>

<script>
export default {
    name: 'FormInput',
};
</script>
